import { FE_UNSUB_BY_MARKETING_TYPE_241213 } from "@faire/retailer-settings/FE_UNSUB_BY_MARKETING_TYPE_241213";
import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
export var useSettingEnableUnsubscribeByMarketingType = function() {
    return useSetting(FE_UNSUB_BY_MARKETING_TYPE_241213);
};
